import { render, staticRenderFns } from "./tableSelesaiMagang.vue?vue&type=template&id=6e30211c&scoped=true"
import script from "./tableSelesaiMagang.vue?vue&type=script&lang=js"
export * from "./tableSelesaiMagang.vue?vue&type=script&lang=js"
import style0 from "./tableSelesaiMagang.vue?vue&type=style&index=0&id=6e30211c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e30211c",
  null
  
)

export default component.exports